<template>
    <div>
        <div class="main">
            <div class="nav">
                <el-breadcrumb separator-class="el-icon-arrow-right">
									<el-breadcrumb-item>物资管理</el-breadcrumb-item>
									<el-breadcrumb-item>机械报检</el-breadcrumb-item>
                </el-breadcrumb>
            </div>
						<div class="cont">
							<div class="search">
								<div class="search-l">
									<div class="input"><el-input @change="getData" clearable v-model="sn" placeholder="请输入设备序列号"></el-input></div>
									<div class="input">
										<el-date-picker
											v-model="detectionDate"
											@change="getData" clearable
											type="datetime"
											value-format="yyyy-MM-dd HH:mm:ss"
											placeholder="选择日期时间">
										</el-date-picker>
									</div>
									<div class="btn" @click="getData">搜索</div>
								</div>
								<div class="search-r">
									<div class="btn" @click="exportOut">导出表单</div>
									
									<!-- <div class="btn">添加</div> -->
								</div>
							</div>
							
							<el-table
								:data="dataList"
								height="69.4vh"
								style="width: 100%"
								:header-cell-style="{color:'#909399',fontFamily: 'SourceHanSansCN-Regular',fontSize:'14px',fontWeight: 'normal'}">
								<el-table-column
									prop="date"
									label="序号"
									width="90">
									<template slot-scope="scope">
										{{(pageNum-1)*pageSize+scope.$index+1}}
									</template>
								</el-table-column>
								<el-table-column
									prop="equip_name"
									label="设备名称"
									>
								</el-table-column>
								<el-table-column
									prop="sn"
									label="序列号"
									>
								</el-table-column>
								<el-table-column
									prop="specifications"
									label="型号规格"
									>
								</el-table-column>
								<el-table-column
									prop="installation_unit"
									label="安装单位"
									>
								</el-table-column>
								<el-table-column
									prop="testing_unit"
									label="检测机构"
									>
								</el-table-column>
								<el-table-column
									prop="file_name"
									label="检测报告"
									>
								</el-table-column>

								<el-table-column
									prop="detection_date"
									label="检测时间"
									>
								</el-table-column>
								<el-table-column
									label="安装位置"
									>
									<template slot-scope="scope">
										<div v-show="scope.row.location.lat">
											东经：{{scope.row.location.lat?scope.row.location.lat:''}} </br>北纬：{{scope.row.location.lng?scope.row.location.lng:''}}
										</div>
									</template>
								</el-table-column>
								<!-- <el-table-column
									label="操作"
									width="110"
									>
									<template slot-scope="scope">
										<div class="text" style="color:#2E5BE9" @click="xiangqing(scope.row)">详情</div>
									</template>
								</el-table-column> -->
							</el-table>
							<!-- <el-dialog
								title="详情"
								:visible.sync="dialogVisible"
								width="30%"
								:before-close="handleClose">
								<div class="tab">
									<div class="row">
										<div class="row-l">安装位置</div>
										<div class="row-r"></div>
									</div>
									<div class="row">
										<div class="row-l">进场时间</div>
										<div class="row-r"></div>
									</div>
								</div>
								<span slot="footer" class="dialog-footer">
									<el-button @click="dialogVisible = false">取 消</el-button>
									<el-button type="primary" @click="dialogVisible = false">确 定</el-button>
								</span>
							</el-dialog> -->
							<el-pagination
								@size-change="handleSizeChange"
								@current-change="handleCurrentChange"
								:current-page="pageNum"
								:page-sizes="[10, 20, 30, 40,100,200]"
								:page-size="pageSize"
								layout="total, sizes, prev, pager, next, jumper"
								:total="total"
								>
							</el-pagination>
						</div>
        </div>
    </div>
</template>

<script>
import myHttp from '../../../untils/port'
import util from '../../../untils/util'
import base from '../../../untils/base'
    export default {
        data() {
					return {
						pageNum:1,
						pageSize:10,
						detectionDate:'',
						sn:'',
						dataList:[],
						dialogVisible:false,
						total:''
					}
				},
				mounted(){
					this.getData()
				},
				methods:{
					exportOut(){
						let accessToken = this.$store.state.token
						let projectId = util.session.get('groupId')
						let delFlag = '0'
						let equipType = '1'
						let sn = this.sn
						let detectionDate  =this.detectionDate
						window.open(
							myHttp.exportInMechine + 
							'?projectId='+
							projectId +
							'&delFlag=' + 
							delFlag +
							'&equipType=' +
							equipType +
							'&accessToken=' +
							accessToken +
							'&sn=' +
							sn +
							'&detectionDate='+
							detectionDate
						)
					},
					xiangqing(item){
						this.dialogVisible=true
					},
					handleSizeChange(val){
						this.pageSize = val
						this.pageNum = 1
						this.getData()
					},
					handleCurrentChange(val){
						this.pageNum = val
						this.getData()
					},
					getData(){
						myHttp.selectDistributionMaintenancePageNew({
							pageNum:this.pageNum,
							pageSize:this.pageSize,
							projectId:util.session.get('groupId'),
							sn:this.sn,
							detectionDate:this.detectionDate
						}).then(res=>{
							console.log(res)
							if(res.data.code==200){
								this.dataList = res.data.data.pageInfo.list
								this.total = res.data.data.pageInfo.total
								this.dataList.forEach((item,index)=>{
									this.dataList[index].location = JSON.parse(item.location)
								})
							}
						})
					}
				}
    }
</script>

<style  scoped>
.main{
    height: 90.4vh;
    background-color: #F3F8FC;
    padding: 0 1% 0 0.5%;
}
.nav{
    height: 60px;
		display: flex;
		align-items: center;
}
.el-breadcrumb{
	font-size: 20px;
}
.cont{
	background-color: #fff;
	border-radius: 6px;
	overflow: hidden;
}
.search{
	height: 60px;
	display: flex;
	align-items: center;
	justify-content: space-between;
	border-bottom:1px solid #D8D8D8;
}
.btn{
	width: 100px;
height: 40px;
background: #0B62F0;
border-radius: 6px;
display: flex;
justify-content: center;
align-items: center;
font-size: 18px;
font-family: PingFang SC;
font-weight: 500;
color: #FFFFFF;
}
.btn:hover{
	cursor: pointer;
	opacity: 0.7;
}
.input{
	width: 200px;
height: 40px;
}
.search-l{
	margin-left: 10px;
	display: flex;
	width: 520px;
	justify-content: space-between;
}
.search-r{
	display: flex;
	width: 216px;
	justify-content: end;
	margin-right: 10px;
}
/* ::v-deep .el-table th{
	background-color: #E6E6E6 !important;
} */
.el-pagination{
	background-color: #E6E6E6 ;
}
.el-date-editor.el-input{
	width: 198px !important;
}
.text:hover{
	cursor: pointer;
	opacity: 0.7;
}
.tab{
	width: 100%;
	height: 500px;
	background-color: #f00;
}
.title{
	height: 60px;
	background-color: #E6E6E6 ;
	font-size: 24px;
font-family: PingFang SC;
font-weight: bold;
color: #333333;
display: flex;
justify-content: center;
align-items: center;
}
::v-deep .cell>span{
 font-size: 14px !important;
}

::v-deep .cell{
 font-size: 14px !important;
}
</style>